'use client';
import { IconButtonStyled } from './icon-button.styles';

declare module '@mui/material/IconButton' {
  interface IconButtonPropsColorOverrides {
    tertiary: true;
  }
}

const IconButton = IconButtonStyled;

export default IconButton;
